"use strict";
/**
 * Kernel statistico — primitive pure condivise dalle formule di dominio.
 * Il censimento ha trovato ~10 copie di mean/SD nel backend (quasi tutte
 * popolazione, una campionaria non dichiarata): qui la semantica è ESPLICITA
 * nel nome, mai implicita.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mean = mean;
exports.sdPopulation = sdPopulation;
exports.sdSample = sdSample;
exports.round = round;
function mean(values) {
    if (values.length === 0)
        return 0;
    return values.reduce((s, v) => s + v, 0) / values.length;
}
/** Deviazione standard di POPOLAZIONE (divisore N) — la convenzione LeoPart. */
function sdPopulation(values) {
    if (values.length === 0)
        return 0;
    const m = mean(values);
    return Math.sqrt(mean(values.map((v) => (v - m) ** 2)));
}
/** Deviazione standard CAMPIONARIA (divisore N−1). Usarla solo dichiarandolo. */
function sdSample(values) {
    if (values.length < 2)
        return 0;
    const m = mean(values);
    const ss = values.reduce((s, v) => s + (v - m) ** 2, 0);
    return Math.sqrt(ss / (values.length - 1));
}
/** Arrotondamento a N decimali (default 2) — convenzione output formule. */
function round(value, decimals = 2) {
    const f = 10 ** decimals;
    return Math.round(value * f) / f;
}
